import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  label
}) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      {label && (
        <span className="mr-3 text-sm font-medium text-gray-700">{label}</span>
      )}
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div
          className={`block w-10 h-6 rounded-full ${
            disabled
              ? 'bg-gray-300'
              : checked
              ? 'bg-primary'
              : 'bg-gray-200'
          } transition`}
        />
        <div
          className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform transform ${
            checked ? 'translate-x-4' : ''
          } ${disabled ? 'opacity-60' : ''}`}
        />
      </div>
    </label>
  );
};

export default Toggle;
